import { InvitationHeaderContainer } from "@platform/features/invitation";
import { useRedirectWhenNoInvitation } from "@platform/hooks/useRedirectWhenNoInvitation";
import { FlowLayout } from "./FlowLayout";

export type Props = {
  title: string;
};

export const InvitationLayout = ({ title }: Props) => {
  const { isValidating, isValidated } = useRedirectWhenNoInvitation();

  const isLoading = isValidating || !isValidated;

  return (
    <FlowLayout
      title={title}
      isLoading={isLoading}
      header={<InvitationHeaderContainer />}
    />
  );
};

export default InvitationLayout;
